import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { environment } from '@environments/environment';
import { ProductionReport } from '@app/models/production/production-report';
import { CurrentShift } from '@app/models/shift/current-shift';

@Injectable({
  providedIn: 'root',
})
export class ShiftProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly apiUrl = `${environment.proxyUrls.productionApi}/api/v1/current-shift`;
  private readonly apiProductionUrl = environment.proxyUrls.productionApi;

  getCurrentShift(): Observable<ApiResponse<CurrentShift>> {
    return this.httpClient.get<ApiResponse<CurrentShift>>(this.apiUrl);
  }

  updateShift(id: string, shift: CurrentShift): Observable<ApiResponse<CurrentShift>> {
    return this.httpClient.put<ApiResponse<CurrentShift>>(`${this.apiUrl}/${id}`, shift);
  }

  downloadShiftReport(command: ProductionReport, timezoneOffset = 0): Observable<Blob> {
    return this.httpClient.post(
      `${this.apiProductionUrl}/api/v1/knitting-production/report?generatePdf=true&timezoneOffset=${timezoneOffset}`,
      command,
      {
        responseType: 'blob',
      },
    );
  }
}
